import React, { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import CommonMuiTable, { Table } from "../../Component/Table/Table";
import { success, vector } from "../../assets/img";
import { Margin, usePDF } from 'react-to-pdf';
import { URLS } from "../../Services/Constant";
import { get } from "../../Services/ApiHandler";
import DownloadPdf from "../../Component/DownloadPdf";
import moment from "moment";
import { Toast } from "../../Component/Toast";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import CustomScroll from "../../Component/CustomScroll";
import { MaskIcon } from "../../Component/MaskIcon";


const PurchaseReport = () => {


    const debounceTimer = useRef(null);
    const [page, setPage] = useState(1);

    const [pagination, setPagination] = useState("");
    const [downSuccess, setDownSuccess] = useState(false);
    const [search, setSearch] = useState("");

    const location = useLocation();
    const listData = location.state?.listData;
    const slotId = location.state?.slotId;
    const resportName = location.state?.resportName;
    const mobile = location.state?.mobile;
    const lot_name = location.state?.lot_name;
    const time = location.state?.time;
    const date = location.state?.date;

    const { toPDF, targetRef } = usePDF({
        filename: `${`KANDHApurchasereport_${date}_${time}`}.pdf`,
        page: { margin: Margin.MEDIUM, orientation: 'portrait' },
    });

    const [loading, setLoading] = useState(false);

    const [list, setList] = useState(listData || []);

    const fetchList = async (searchValue = "") => {
        const res = await get(
            `${URLS.SALESREPORT}/${resportName}?${slotId}&mobile=${mobile}&search=${searchValue}`
        );

        if (res?.status === "success") {
            setList(res);
        }
    };

    const handleSearchChange = (e) => {
        const value = e.target.value;
        setSearch(value);

        if (debounceTimer.current) {
            clearTimeout(debounceTimer.current);
        }

        debounceTimer.current = setTimeout(() => {
            fetchList(value);
        }, 400);
    };
    const handleClearSearch = () => {
        setSearch("");

        if (debounceTimer.current) {
            clearTimeout(debounceTimer.current);
        }

        fetchList("");
    };

    useEffect(() => {
        return () => {
            if (debounceTimer.current) {
                clearTimeout(debounceTimer.current);
            }
        };
    }, []);
    useEffect(() => {
        const handleBeforeUnload = () => {
            sessionStorage.setItem("pageReloaded", "true");
        };

        window.addEventListener("beforeunload", handleBeforeUnload);

        return () => {
            window.removeEventListener("beforeunload", handleBeforeUnload);
        };
    }, []);


    useEffect(() => {
        const wasReloaded = sessionStorage.getItem("pageReloaded");

        if (wasReloaded === "true") {
            fetchList();
            sessionStorage.removeItem("pageReloaded"); // important
        }
    }, []);



    const columns = React.useMemo(
        () => [
            {
                Header: "Date",
                accessor: "date",
                Cell: ({ value, row }) => {
                    return <p className="text-nowrap">{value}</p>;
                },
            },
            {
                Header: " Time",
                accessor: "time",
                Cell: ({ value, row }) => {
                    return <p className="text-nowrap">{value}</p>;
                },
            },
            {
                Header: " Lot",
                accessor: "lot",
                Cell: ({ value, row }) => {
                    return <p className="text-nowrap">{value === "Kerala" ? "Kerala" : "Dear"}</p>;
                },
            },
            {
                Header: "Lot Details",
                accessor: "lot_details",
                Cell: ({ value }) => {
                    const text = value || "";

                    const lower = text.toLowerCase();
                    let index = -1;

                    if (lower.includes("dear")) {
                        index = lower.indexOf("dear");
                    } else if (lower.includes("kerala")) {
                        index = lower.indexOf("kerala");
                    }

                    let firstLine = text;
                    let secondLine = "";

                    if (index !== -1) {
                        firstLine = text.substring(0, index).trim();
                        secondLine = text.substring(index).trim();
                    }

                    return (
                        <div>
                            <p>{firstLine}</p>
                            {secondLine && <p>{secondLine}</p>}
                        </div>
                    );
                },
            },

            {
                Header: "Lot No",
                accessor: "my_number",
                Cell: ({ value, row }) => {
                    return <p className="text-nowrap">{value}</p>;
                },
            },
            {
                Header: "Qty",
                accessor: "qty",
                Cell: ({ value, row }) => {
                    return <p className="text-nowrap">{value}</p>;
                },
            },
            {
                Header: "Price",
                accessor: "fees",
                Cell: ({ value, row }) => {
                    return <p className="text-nowrap">{value}</p>;
                },
            },
            {
                Header: "Result",
                accessor: "announce_status",
                Cell: ({ value, row }) => {
                    return (
                        <div className="d-flex ac-jc">
                            <button
                                // onClick={() => {
                                //     handleStatus(row);
                                // }}
                                className={`${value === "Announced" ? "paid" : "not_paid"
                                    } border-0 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-13 f2`}
                            >
                                {value}
                            </button>
                        </div>
                    );
                },
            },
        ],
        []
    );

    const generatePdf = (rows) => {
        const doc = new jsPDF("p", "mm", "a4");

        const pageWidth = doc.internal.pageSize.getWidth();

        // ---- HEADER TEXT ----
        doc.setFont("helvetica", "bold");
        doc.setFontSize(15);
        doc.text("Kandha Agency – Purchase Report", pageWidth / 2, 15, {
            align: "center",
        });

        doc.setFontSize(10);
        doc.setFont("helvetica", "bold");
        doc.text(
            `Date: ${moment(date).format("DD-MM-YYYY")}  |  Lot: ${lot_name}  |  Time: ${time}`,
            pageWidth / 2,
            22,
            { align: "center" }
        );

        doc.text(
            `Report Generated on: ${moment(new Date()).format("DD-MM-YYYY hh:mm a")}`,
            pageWidth / 2,
            28,
            { align: "center" }
        );

        // ---- DIVIDER LINE ----
        doc.setLineWidth(0.5);
        doc.line(10, 32, pageWidth - 10, 32);

        // ---- TABLE ----
        autoTable(doc, {
            startY: 36, // IMPORTANT: start after header
            head: [["Date", "Time", "Lot", "Lot Details", "Lot No", "Qty", "Price", "Result"]],
            body: rows.map((r) => [
                r.date,
                r.time,
                r.lot,
                r.lot_details,
                r.my_number,
                r.qty,
                r.fees,
                r.announce_status,
            ]),

            foot: [[
                {
                    content: "Total Amount",
                    colSpan: 6,
                    styles: { halign: "right" }
                },
                {
                    content: `Rs. ${list?.total_amount ?? 0}`,
                    colSpan: 2,
                    styles: { halign: "left" }
                }
            ]],

            showFoot: "lastPage",
            styles: {
                fontStyle: "bold",
                textColor: 'black',
                fontSize: 10,
                cellPadding: 1,
                overflow: "linebreak",
                lineWidth: 0.1,
                lineColor: [200, 200, 200]
            },
            headStyles: {
                fillColor: [143, 13, 61],   // #8F0D3D
                textColor: [255, 255, 255],
                lineWidth: 0.5,       // Header border thicker
                valign: "middle",
                halign: "center",
            },
            footStyles: {
                fontSize: 12,
                fontStyle: "bold",
                halign: "left",
                fillColor:  [220, 169, 185]
            },
            margin: 5,
        });

        doc.save(`KANDHApurchasereport_${moment(date).format("DD-MM-YYYY")}_${time}.pdf`);
    };




    const handleDownload = async () => {
        if (!list?.data?.length) {
            Toast("No data available to download");
            return;
        }

        try {
            setLoading(true);
            await generatePdf(list?.data);
            setDownSuccess(true);
        } catch (error) {
            console.error(error);
            Toast("Failed to download PDF");
        } finally {
            setLoading(false);
        }
    };


    const [browsHeader, setBrowsHeader] = useState(true);

    const maxHeight = useRef(window.visualViewport?.height || window.innerHeight);
    const isFirstRun = useRef(true);

    useEffect(() => {
        const handleResize = () => {
            const visibleHeight = window.visualViewport?.height || window.innerHeight;

            // 🔹 Skip logic on first run
            if (isFirstRun.current) {
                isFirstRun.current = false;
                setBrowsHeader(true);
                return;
            }

            // 🔻 Viewport reduced (keyboard / browser UI)
            if (visibleHeight < maxHeight.current) {
                setBrowsHeader(true);

            }
            // 🔺 Viewport restored
            else {
                maxHeight.current = visibleHeight;
                setBrowsHeader(false);
            }
        };

        window.visualViewport?.addEventListener("resize", handleResize);

        return () => {
            window.visualViewport?.removeEventListener("resize", handleResize);
        };
    }, [browsHeader]);

    return (
        <div style={{
            // marginBottom: browsHeader ? 75 : 42,
            // paddingBottom: browsHeader ? 94 : 45
        }} className="dashRightView marginScrolls d-flex ac-jb flex-column">
            <CustomScroll height="100vh">
                <div className="container_overallss">
                    <div style={{ marginRight: 22, marginBottom: 22 }} className="d-flex ac-je">
                        {loading ? (
                            <span
                                className="spinner-border spinner-border-sm"
                                style={{ color: "#8F0D3d", width: 12, height: 12 }}
                            />
                        ) : downSuccess ? (
                            <img src={success} height={20} />
                        ) : (
                            <MaskIcon onClick={handleDownload} src={vector} height={15} />
                        )}
                    </div>
                    <div
                        style={{
                            padding: "0 0px 10px",
                        }}
                    >
                        <div className="form-group col-md-5 text-start my-3">
                            <label className="form-label f3 fs-md-14 fs-lg-16 m-0 primary1">
                                Search
                            </label>

                            <div
                                className="login-input1 mt-1"
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                }}
                            >
                                <input
                                    value={search}
                                    onChange={handleSearchChange}
                                    type="text"
                                    placeholder="Search..."
                                    className="placholdercolorchanges2 fs-xs-15 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20"
                                    style={{
                                        flex: 1,
                                        border: "none",
                                        outline: "none",
                                        background: "transparent",
                                        padding: "0 10px",
                                        height: 50,
                                    }}
                                />

                                {search && (
                                    <button
                                        onClick={handleClearSearch}
                                        style={{
                                            background: "transparent",
                                            border: "none",
                                            cursor: "pointer",
                                            color: "#8F0D3d",
                                            fontSize: 20,
                                            lineHeight: 1,
                                            padding: "0 12px",
                                            flexShrink: 0,
                                        }}
                                    >
                                        ×
                                    </button>
                                )}
                            </div>
                        </div>
                    </div>
                    <Table
                        columns={columns}
                        setPageno={setPage}
                        pagecount={pagination}
                        data={list?.data || []}
                        show={false}
                    />
                </div>

            </CustomScroll>
            <div className="d-flex ac-jb px-3 team_size">
                <p className="f3 fs-sm-14 white">
                    Total Amount
                </p>
                <p className="f3 fs-sm-14 white">
                    {`₹ ${list?.total_amount || 0}`}
                </p>
            </div>
        </div>
    );
};

export default PurchaseReport;
